
export function getWeightBetweenValues(value: number, lowerBound: number, upperBound: number) {
  if (lowerBound === upperBound) 
    return 1;
  return (value - lowerBound) / (upperBound - lowerBound);
}